// extracted by mini-css-extract-plugin
export default {"container":"StatusProposta_container__kH3Yk","header":"StatusProposta_header__8looH"};